import React, { Component } from "react"
import { MDBBtn, MDBIcon } from "mdbreact"
import ApiRest from "../../ayudas/apiRest"
import _valid from "../../validations"
import { Card, Collapse, CardTitle, CardBody, Col, Container, Media, Label, Input, Row } from 'reactstrap'
import Breadcrumbs from '../../components/Common/Breadcrumb'
import { Pie } from 'react-chartjs-2'
import { Link } from "react-router-dom"
import toastr from "toastr"
import Select from 'react-select';
import 'chart.piecelabel.js';

export default class graficaTipoSolicitud extends Component {
    constructor(props) {
        super(props);

        this.apiRest = new ApiRest();

        this.state = {
            registro: _valid(this.props.location.registro) ? this.props.location.registro : {
                titulo: "",
                descripcion: "",
                url_img_ns: "url_temp",
                img_nueva_solicitud: null,
                estado: 0,
                prioridad: 0,
                solicitar_a: null,
                lugar_ubicacion: null,
                tipo_solicitud: null,
                proyecto: null,
                colaborador: null,
                fecha_programada: null,
                fecha_fin: null,
                horas: 0,
                razon_rechazo: null,
                valor: 0,
                img_calificacion: null
            },
            fechaFin: null,
            fechaMin: null,
            solicitar_a: null,
            lugar_ubicacion: null,
            tipo_solicitud: null,
            ubicaciones: [],
            tiposSolicitudes: [],
            departamentosAreas: [],
            colapsar: true,
            solicitudes: [],
            colores: [],
            descripcion: [],
            data: [],
            opciones: [],
            campos: [],
            valores: [],
            numeroTemporal: [],
            total: 0
        };
        this.buscar = this.buscar.bind(this);
        this.getInformacion = this.getInformacion.bind(this);
        this.actualizarValores = this.actualizarValores.bind(this);
        this.borrarFiltros = this.borrarFiltros.bind(this);

    }

    async componentDidMount() {
        localStorage.removeItem("datos");
        this.getInformacion();
        let id = null;
        if (this.apiRest.getRol()) {
            this.getDepartamentoArea();
        } else {
            id = this.apiRest.getLS('du').colaborador.id;
            this.obtenerDepartamentoLoggeado(id);
        }
        localStorage.removeItem("result");
    }

    obtenerDepartamentoLoggeado = (id) => {
        if (_valid(id)) {
            this.apiRest.get('/departamentoLoggeado/' + id).then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ departamentosAreas: this.formatoLabel(resultado) });
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
            });
        }
    }

    formatoLabel = valores => valores.data.map(i => ({ value: i.id_departamento, label: i.departamento }));

    //genera un caracter 
    generarCaracter() {
        let caracter = ['a', 'b', 'c', 'd', 'e', 'f', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
        let numero = (Math.random() * 15).toFixed(0);
        return caracter[numero];
    }

    //color hexadecimales
    generarColorHex() {
        let color = "";
        for (let i = 0; i < 6; i++) {
            color += this.generarCaracter();
        }
        return "#" + color;
    }

    //generando la cadena de colores
    generarColores() {
        let color = [];
        for (let i = 0; i < this.state.tiposSolicitudes.length; i++) {
            color.push(this.generarColorHex())
        }
        this.setState({ colores: color })
    }

    cambiosSolicitarA = asignado => {
        this.setState({ solicitar_a: asignado });
        if (_valid(asignado)) {
            this.getTipoSolicitud(asignado.value)
        } else {
            this.setState({ tiposSolicitudes: [] });
            this.setState({ campos: [] });
            this.setState({ descripcion: [] });
        }
    }

    colapsar() {
        this.setState(estadoAnterior => ({ colapsar: !estadoAnterior.colapsar }));
    }

    actualizarValores = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            ...estadoAnterior, [name]: value
        }));
    }

    cambiosUbicacion = lugar => {
        this.setState({ lugar_ubicacion: lugar });
    }

    //formatear la seleccion
    formato = valores => valores.data.map(i => ({ value: i.id, label: i.nombre }));
    formatoTexto = valores => valores.data.map(i => ({ value: i.id, label: i.texto_area }));
    formato2 = valores => valores.data.map(i => (i.nombre));
    formato3 = valores => valores.data.map(i => ({ value: i.nombre, label: i.descripcion }));
    formatoubicacion = valores => valores.data.map(i => ({ value: i.id, label: i.ubicacion_texto }));

    getDepartamentoArea = () => {
        //obtener departamento
        this.apiRest.get('/departamentoArea').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ departamentosAreas: this.formatoTexto(resultado) });
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    //traer informacion para los select de la vista
    async getInformacion() {

        if (this.apiRest.getRol()) {
            //obtener tipo de solicitudes
            this.apiRest.get('/tipoSolicitud').then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ tiposSolicitudes: resultado.data });
                    this.setState({ campos: this.formato2(resultado) });
                    this.setState({ descripcion: this.formato3(resultado) });
                    this.generarColores();
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
            });
            //obtener ubicacion
            this.apiRest.get('/ubicacion').then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ ubicaciones: this.formatoubicacion(resultado) });
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
            });
        }
    }

    configurarGrafica(total) {
        const t = total;
        const data = {
            labels: this.state.campos,
            datasets: [{
                data: this.state.valores,
                backgroundColor: this.state.colores
            }]
        };
        const opciones = {
            responsive: true,
            maintainAspectRation: false,
            pieceLabel: {
                render: function (args) {
                    return args.label + " " + Math.trunc((args.value * 100) / t) + "%"
                },
                fontSize: 15,
                fontColor: '#110700',
                fontFamily: 'Tahoma'
            }
        }
        this.setState({ data: data, opciones: opciones });
    }

    //valida si todos los campos estan vacios
    validar = (filtro) => {
        let boleano = false;
        if (_valid(filtro.fechaFin, filtro.fechaMin)) {
            boleano = true;
        } else {
            if (_valid(filtro.fechaMin) == true) { toastr.error('Fecha no valida.') }
            if (_valid(filtro.fechaFin) == true) { toastr.error('Fecha no valida.') }
        }
        if (this.apiRest.getRol()) {
            if (_valid(filtro.solicitar)) {
                boleano = true;
            } else {
                boleano = false;
                toastr.error('Debe elegir un departamento.');
            }
        } else {
            if (_valid(filtro.solicitar)) {
                boleano = true;
            } else {
                boleano = false;
                toastr.error('Debe elegir un departamento.');
            }
        }
        return boleano;
    }

    valoresNumericos = (cadena) => {
        let campo = this.state.campos
        let number = this.state.numeroTemporal
        campo.forEach((element, index) => {
            switch (cadena) {
                case element:
                    if (number[index] == null) {
                        number[index] = 1;
                    } else {
                        number[index] = 1 + number[index];
                    }
                    break;
                default:
                    break;
            }
        });
    }

    getTipoSolicitud = (id) => {
        //obtener tipo de solicitudes
        this.apiRest.get('/tipoSolicitudPorDepartamento/' + id).then(resultado => {
            if (resultado.exitoso) {
                this.setState({ tiposSolicitudes: resultado.data });
                this.setState({ campos: this.formato2(resultado) });
                this.setState({ descripcion: this.formato3(resultado) });
                this.generarColores();
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    //metodo para exportar los datos a graficar
    exportarData = (datos) => {
        let array = null;
        array = datos
        if (_valid(array)) {
            const auth = this.apiRest.getLS('authUser');
            if (auth !== null) {
                const headers = {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.access },
                    responseType: 'blob',
                    body: JSON.stringify(datos ? datos : '')
                }
                fetch(process.env.REACT_APP_API_URL + "/graficaGenerica", headers).then(
                    resp => {
                        if (resp.status >= 200 && resp.status < 300) {
                            resp.blob().then(blob => {
                                const url = window.URL.createObjectURL(blob);
                                const a = document.createElement("a");
                                a.style.display = "none";
                                a.href = url;
                                // the filename you want
                                a.download = "grafica.xlsx";
                                document.body.appendChild(a);
                                a.click();
                                window.URL.revokeObjectURL(url)
                            });
                        } else if (resp.status === 401) {
                            this.props.history.push('/Timeout');
                        }
                    }
                );
            } else {
                toastr.error('Vaya! No loggeado, por favor intenta nuevamente.');
                this.props.history.push('/Timeout');
            }
        } else {
            toastr.error('No hay datos para procesar');
        }
    }

    //metodo para extraer los valores de los estados para usar en la grafica
    valor = (solicitudes) => {

        this.setState({ numeroTemporal: [] });
        let tipoSolicitud = this.state.tiposSolicitudes
        let array = [];
        if (Object.keys(solicitudes).length === 0) {
            this.setState({ valores: [] });
            toastr.error('Vaya! No se encontro informacion, por favor intenta nuevamente.');
        } else {
            toastr.success('Procesando solicitud espere un momento por favor');
            for (let i = 0; i < solicitudes.length; i++) {
                for (let j = 0; j < tipoSolicitud.length; j++) {
                    if (solicitudes[i].tipo_solicitud == tipoSolicitud[j].id) {
                        this.valoresNumericos(solicitudes[i].tipo_solicitud_nombre);
                    }
                }
            }
            array = this.state.numeroTemporal
            let array2 = [];
            for (let i = 0; i < array.length; i++) {
                if (array[i] != null) {
                    array2[i] = array[i]
                } else {
                    array2[i] = 'empty';
                }
            }
            this.setState({ valores: [] });
            this.setState({ valores: array2 });
        }
        let total = this.state.valores;
        let sumaTotal = 0;
        for (let i = 0; i < total.length; i++) {
            if (_valid(total[i])) {
                if (total[i] != 'empty') {
                    sumaTotal += total[i]
                }
            }
        }
        this.configurarGrafica(sumaTotal);
    }

    //metodo para buscar la data filtrada
    buscar = () => {
        const {
            fechaMin,
            fechaFin,
            solicitar_a,
            lugar_ubicacion,
            tipo_solicitud
        } = this.state
        let solicitar = null;
        let lugar = null;
        let tipo = null;
        if (solicitar_a !== null) {
            solicitar = solicitar_a.value;
        }

        if (lugar_ubicacion !== null) {
            lugar = lugar_ubicacion.value;
        }
        if (tipo_solicitud !== null) {
            tipo = tipo_solicitud.value;
        }

        const filtro = {
            fechaMin,
            fechaFin,
            solicitar,
            lugar,
            tipo
        }

        if (this.validar(filtro)) {
            this.apiRest.put('/solicitudFiltrar', filtro).then(respuesta => {
                if (respuesta.exitoso) {
                    localStorage.setItem('result', JSON.stringify(respuesta.data));
                    this.valor(respuesta.data);
                } else {
                    this.props.history.push('/Timeout');
                }
            });
        } else {
            this.setState({ valores: [] });
        }
    }

    //descarga de excel grafica
    descargarExcel = () => {
        let result = JSON.parse(localStorage.getItem('result'));
        console.log(result);
        if (_valid(result)) {
            this.exportarData(result);
            localStorage.removeItem("result");
        } else {
            toastr.error('No hay datos para procesados realize una busqueda primero');
        }
    }

    borrarFiltros = () => {
        this.setState({
            fechaFin: null, fechaMin: null,
            solicitar_a: null,
            lugar_ubicacion: null
        })
        this.setState({
            fechaFin: '', fechaMin: '',
            solicitar_a: '',
            lugar_ubicacion: ''
        })
    }

    render() {
        const {
            colapsar,
            fechaMin,
            fechaFin,
            departamentosAreas,
            lugar_ubicacion,
            ubicaciones,
            solicitar_a,
        } = this.state;
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Mesa de Servicio" breadcrumbItem="Gráfica Tipo de Solicitudes" />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <Link onClick={() => this.colapsar()} className="text-dark" to="#">
                                            <div className="p-4">
                                                <Media className="d-flex align-items-center">
                                                    <div className="me-3">
                                                        <i className="uil uil-receipt text-primary h2"></i>
                                                    </div>
                                                    <div className="flex-1 overflow-hidden">
                                                        <h5 className="font-size-16 mb-1">Gr&aacute;fica Tipo de Solicitud</h5>
                                                        <p className="text-muted text-truncate mb-0">Por favor, seleccione una opci&oacute;n.</p>
                                                    </div>
                                                    <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                </Media>
                                            </div>
                                        </Link>
                                        <Collapse isOpen={colapsar}>
                                            <form>
                                                <div className="p-4 border-top">
                                                    <Row>
                                                        <Col lg={3}>
                                                            <Label htmlFor="fechaMin" className="form-label">
                                                                Desde la fecha
                                                            </Label>
                                                            <Input
                                                                value={fechaMin}
                                                                onChange={this.actualizarValores}
                                                                name="fechaMin"
                                                                type="date"
                                                            />
                                                        </Col>
                                                        <Col lg={3}>
                                                            <Label htmlFor="fechaFin" className="form-label">
                                                                Hasta la fecha
                                                            </Label>
                                                            <Input
                                                                value={fechaFin}
                                                                onChange={this.actualizarValores}
                                                                name="fechaFin"
                                                                type="date"
                                                            />
                                                        </Col>
                                                        <Col lg={3}>
                                                            <Label htmlFor="solicitar_a" className="form-label">
                                                                Departamento/Área
                                                            </Label>
                                                            <Select
                                                                name="solicitar_a"
                                                                options={departamentosAreas}
                                                                value={solicitar_a}
                                                                onChange={this.cambiosSolicitarA}
                                                                className="basic-single"
                                                                classNamePrefix="select"
                                                                placeholder="Selecciona.."
                                                                isClearable={true}
                                                                isSearchable={true}
                                                                noOptionsMessage={() => "No hay más opciones"}
                                                            />
                                                        </Col>
                                                        {
                                                            this.apiRest.getRol() ?
                                                                <Col lg={3}>
                                                                    <Label htmlFor="lugar_ubicacion" className="form-label">
                                                                        Ubicación
                                                                    </Label>
                                                                    <Select
                                                                        name="lugar_ubicacion"
                                                                        options={ubicaciones}
                                                                        value={lugar_ubicacion}
                                                                        onChange={this.cambiosUbicacion}
                                                                        className="basic-single"
                                                                        classNamePrefix="select"
                                                                        placeholder="Selecciona.."
                                                                        isClearable={true}
                                                                        isSearchable={true}
                                                                        noOptionsMessage={() => "No hay más opciones"}
                                                                    />
                                                                </Col>
                                                                : ''
                                                        }
                                                    </Row>
                                                    <p />
                                                    <Row>
                                                        <Col>
                                                            <MDBBtn className="waves-effect" color="success" onClick={this.buscar}>
                                                                <MDBIcon icon="fas fa-search" />{' '}
                                                                Buscar
                                                            </MDBBtn>
                                                            {' '}
                                                            <MDBBtn className="waves-effect" color="success" onClick={this.descargarExcel}>
                                                                <MDBIcon icon="fas fa-book" />{' '}
                                                                Exportar
                                                            </MDBBtn>
                                                            {' '}
                                                            <MDBBtn className="waves-effect" color="warning" onClick={this.borrarFiltros}>
                                                                <MDBIcon icon="fas fa-trash-alt" />{' '}
                                                                Borrar Filtros
                                                            </MDBBtn>
                                                        </Col>
                                                    </Row>
                                                    {' '}
                                                </div>
                                            </form>
                                        </Collapse>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12}>
                                <Card>
                                    <CardBody>
                                        <div style={{ width: '90%', height: '75%' }}>
                                            <CardTitle className="mb-4">Tipo de solicitudes</CardTitle>
                                            <Pie data={this.state.data} options={this.state.opciones} />
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12} className="text-end">
                                <MDBBtn className="waves-effect" color="danger" onClick={() => { this.props.history.replace('/dashboard') }}>
                                    <MDBIcon icon="fas fa-arrow-left" />{' '}
                                    Regresar
                                </MDBBtn>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}